import {useApiConsumerClient, useApiUrlBuilder} from "shared/tools";
import {SaveStepRequest, SaveStepResponse, ResumeArtResponse} from "../../art";

export function useAssemblyBricksApi() {
  const api = useApiConsumerClient();
  const apiUrlBuilder = useApiUrlBuilder();

  return {
    brickSave: (data: SaveStepRequest) => api.post<SaveStepRequest, SaveStepResponse>({
      path: apiUrlBuilder.consumerSaveArtStep(),
      data
    }),
    resumeArt: (sessionId: string) =>
      api.post<string, ResumeArtResponse>({
        path: apiUrlBuilder.consumerResumeArt(sessionId),
      }),

    skipStepsArt: (sessionId: string, skip: number) =>
      api.post<string, ResumeArtResponse>({
        path: apiUrlBuilder.consumerSkipStepsArt(sessionId, skip),
      }),
  }
}
